@if (!expanded) {
  {{ shortText }}<span class='cursor-pointer hover:underline' (click)='expand()'>(...)</span>
} @else {
  {{ fullText }}
}
